import React, { useState } from 'react';

const TaskManager = () => {
  const [tasks] = useState([
    { id: 1, text: 'Sample Task 1', status: 'Pending', priority: 'Normal' },
    { id: 2, text: 'Sample Task 2', status: 'In Progress', priority: 'High' },
    { id: 3, text: 'Sample Task 3', status: 'Completed', priority: 'Urgent' },
  ]);

  return (
    <div>
      <h2>Task & Priority Management</h2>
      <div>
        <h3>Add New Task</h3>
        {/* Add task form will go here */}
      </div>
      <div>
        <h3>Task List</h3>
        <ul>
          {tasks.map(task => (
            <li key={task.id}>
              <strong>{task.text}</strong> - {task.status} ({task.priority})
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TaskManager;
